export default angular.module('KisanHubAccountAccess', [
    'ngMaterial',
    'mdIcons'
])
    .config(['$mdThemingProvider',
        function ($mdThemingProvider) {
            $mdThemingProvider.theme('default')
                .primaryPalette('green')
                .accentPalette('blue');
        }]);